// extracted by mini-css-extract-plugin
module.exports = {"Container":"_3PuX7fG_C7p7zYJCy1Bwqr","Information":"lNMY57U4LJwrBV-Brx7Q0","Text":"_3TKbbNjKphZsbPylMMYIFS"};